import {
  ACCOUNT_TYPE_CORPORATE, ACCOUNT_TYPE_PRIVATE, USER_ROLE_ADMIN, USER_ROLE_MODERATOR, VIEW_ADVERTISER, VIEW_EMPLOYER
} from '../../../constants'
import { isUnderage } from '../../../utils/user'

export default {
  user: state => state.user,
  userId: state => state.user.id,
  email: state => state.user.email,
  acceptedPolicyVersion: state => state.user.acceptedPolicyVersion,

  hasValidProfile: state => {
    if (state.user.accountType === ACCOUNT_TYPE_PRIVATE) {
      return !!(
        state.user.phone &&
        state.user.privateAccount.firstName &&
        state.user.privateAccount.lastName &&
        state.user.privateAccount.gender &&
        state.user.privateAccount.birthDate &&
        state.user.privateAccount.citizenship &&
        state.user.privateAccount.residenceLoc &&
        state.user.privateAccount.residenceLoc.cityId &&
        state.user.privateAccount.residenceLoc.countryId &&
        state.user.privateAccount.residenceLoc.countyId
      )
    } else {
      return !!(
        state.user.phone &&
        state.user.corporateAccount.companyName &&
        state.user.corporateAccount.officeLoc &&
        state.user.corporateAccount.officeLoc.cityId &&
        state.user.corporateAccount.officeLoc.countryId &&
        state.user.corporateAccount.officeLoc.countyId
      )
    }
  },

  isUnderage: state => state.user.privateAccount ? isUnderage(state.user.privateAccount.birthDate) : false,
  fullName: state => state.user.privateAccount
    ? `${state.user.privateAccount.lastName} ${state.user.privateAccount.firstName}`
    : '',
  companyName: state => state.user.corporateAccount ? state.user.corporateAccount.companyName : '',
  rawAddress: state => {
    let address
    if (state.user.accountType === ACCOUNT_TYPE_PRIVATE) {
      address = (
        state.user.privateAccount &&
        state.user.privateAccount.residenceLoc &&
        state.user.privateAccount.residenceLoc.raw
      ) ? state.user.privateAccount.residenceLoc.raw : null
    } else {
      address = (
        state.user.corporateAccount &&
        state.user.corporateAccount.officeLoc &&
        state.user.corporateAccount.officeLoc.raw
      ) ? state.user.corporateAccount.officeLoc.raw : null
    }

    return address
  },

  isAdmin: state => state.user.role === USER_ROLE_ADMIN,
  isPrivileged: state => [USER_ROLE_ADMIN, USER_ROLE_MODERATOR].includes(state.user.role),

  isAuthenticated: state => state.isAuthenticated,
  isPrivate: state => state.user.accountType === ACCOUNT_TYPE_PRIVATE,
  isCorporation: state => state.user.accountType === ACCOUNT_TYPE_CORPORATE,

  profileUrl: state => {
    if (state.user.accountType === ACCOUNT_TYPE_CORPORATE) {
      return '/profil/munkaado'
    } else {
      return `/profil/${state.view === VIEW_ADVERTISER ? 'munkakereso' : 'munkaado'}`
    }
  },

  view: state => state.view,
  isAdvertiserView: state => state.view === VIEW_ADVERTISER,
  isEmployerView: state => state.view === VIEW_EMPLOYER,

  averageRating: state => state.user.ratingCount
    ? (state.user.rating1Avg + state.user.rating2Avg + state.user.rating3Avg) / 3
    : 0,
  ratingsReceived: state => state.ratings.received,
  ratingsGiven: state => state.ratings.given
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js